// extracted by mini-css-extract-plugin
export default {"preview":"wX","video":"xX","guidence":"yX","points":"zX","point":"AX","get_started":"BX"};
    if(module.hot) {
      // 1715188239204
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  